import { createSlice } from '@reduxjs/toolkit';
import { ASSETS_PREVIEW } from '@/types/shared/navigation-tabs.enums';

export type DataType = 'duration' | 'count';

interface assetsPreviewState {
  showAlarms: boolean;
  metric: 'duration' | 'count';
  group_by: 'components' | 'alarms' | 'assets';
  chart_group_by: 'components' | 'alarms' | 'assets';
  top_ranked?: number;
  asset_types?: string[] | null;
  from_date?: string;
  to_date?: string;
  selectedPriorityOptions: string[];
  asset_ids?: string[] | null;
  component_ids?: string[] | null;
  selectedSeverityOptions: string[];
  selectedInterfaceOptions: string[];
}

const initialState: assetsPreviewState = {
  showAlarms: true,
  metric: 'count',
  top_ranked: 7,
  group_by: 'alarms',
  chart_group_by: 'components',
  asset_types: null,
  selectedPriorityOptions: [],
  asset_ids: null,
  component_ids: null,
  selectedSeverityOptions: [],
  selectedInterfaceOptions: [],
};

const alarmsSlice = createSlice({
  initialState,
  name: 'alarms',
  reducers: {
    setShowAlarms(state, action) {
      state.showAlarms = action.payload;
    },
    setMetric(state, action) {
      state.metric = action.payload;
    },
    setTopRanked(state, action) {
      state.top_ranked = action.payload;
    },
    setGroupBy(state, action) {
      state.group_by = action.payload;
    },
    setChartGroupBy(state, action) {
      state.chart_group_by = action.payload;
    },
    setAssetType(state, action) {
      state.asset_types = action.payload;
    },
    setSelectedPriorityOptions(state, action) {
      state.selectedPriorityOptions = action.payload;
    },
    setAssetsIds(state, action) {
      state.asset_ids = action.payload === ASSETS_PREVIEW.ALL_ASSETS ? null : [action.payload];
    },
    setComponentIds(state, action) {
      state.component_ids = action.payload === 'all-components' ? null : [action.payload];
    },
    setSelectedSeverityOptions(state, action) {
      state.selectedSeverityOptions = action.payload;
    },
    setSelectedInterfaceOptions(state, action) {
      state.selectedInterfaceOptions = action.payload;
    },
  },
});

export const AlarmsSliceReducer = alarmsSlice.reducer;
export const {
  setShowAlarms,
  setAssetType,
  setAssetsIds,
  setComponentIds,
  setGroupBy,
  setMetric,
  setSelectedPriorityOptions,
  setSelectedSeverityOptions,
  setTopRanked,
  setChartGroupBy,
  setSelectedInterfaceOptions,
} = alarmsSlice.actions;
